import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "text-body2" }

import SOptionGroup from 'SharedComponents/ui/Checkbox/SOptionGroup.vue';
import SSelect from 'SharedComponents/ui/Select/SSelect.vue';
import { ParamsSelectOptions } from 'SharedDir/declarations/fields';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';

export type ValueType = null | string | number | Array<number> | Array<string>;
export interface Props extends PropValue<ValueType> {
  readonly: boolean;
  options: ParamsSelectOptions;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SelectParameter' },
  __name: 'Select',
  props: {
    readonly: { type: Boolean, default: false },
    options: {},
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const { innerValue, emitValue } = useValue(props, emit);

return (_ctx: any,_cache: any) => {
  return (_ctx.options.useDropdown)
    ? (_openBlock(), _createBlock(SSelect, {
        key: 0,
        modelValue: _unref(innerValue),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
          _unref(emitValue)
        ],
        multiple: _ctx.options.multiple,
        filtering: "",
        options: _ctx.options.options,
        readonly: _ctx.readonly,
        label: _ctx.label,
        "option-value": "value",
        "option-label": "label",
        "map-options": "",
        clearable: "",
        outlined: "",
        "options-dense": "",
        dense: "",
        "emit-value": ""
      }, null, 8, ["modelValue", "multiple", "options", "readonly", "label", "onUpdate:modelValue"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
        _createVNode(SOptionGroup, {
          modelValue: _unref(innerValue),
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
            _unref(emitValue)
          ],
          disable: _ctx.readonly,
          type: _ctx.options.multiple ? 'checkbox' : 'radio',
          options: _ctx.options.options
        }, null, 8, ["modelValue", "disable", "type", "options", "onUpdate:modelValue"])
      ]))
}
}

})